import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Form, Row} from "react-bootstrap";
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { testJSON } from '../utils/jsUtils';


const BizConfigAdmin_NewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    name: '',
    description: '',
    config: '{}',
    hasUi: false
  });

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onCheckboxSelect = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.checked });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if (objAttrs.name.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_name") + "50");
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=" + objAttrs.name);

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {
          // Name is taken
          setErrMsg(t("I18N_ERR_Dup_name"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    if (!objAttrs.description || objAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (objAttrs.description.length > 1000) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "1000");

    } else if (!objAttrs.config || objAttrs.config.length === 0) {
      setErrMsg(t("I18N_ERR_Need_config"));
    } else if (   objAttrs.config
               && (objAttrs.config !== '')
               && (!testJSON(objAttrs.config.trim()))) {
      // Validate configuration to be valid JSON
      setErrMsg(t("I18N_ERR_Config_need_valid_JSON"));
    } else {
      createNewModel();
    }
  }

  const createNewModel = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(objAttrs));

    if ((objAttrs.config == null) || (objAttrs.config === '')) {
      reqBody.config = null;
    } else {
      reqBody.config = JSON.parse(objAttrs.config.trim());
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("business-configs", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Config")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Config_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <Row className={classes.admin_pages__field_label}>
            <Col md={3}>{t("I18N_Name")}: *</Col>
            <Col md={3}>{t("I18N_Description")}: *</Col>
            <Col md={3}>{t("I18N_Has_own_ui")}: *</Col>
            <Col></Col>
          </Row>
          <Row className={classes.admin_pages__field_value}>
            <Col md={3}>
              <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={objAttrs.name}
                onChange={(e) => onAttrsInputChange(e)} />
            </Col>
            <Col md={3}>
              <textarea rows={5} className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={objAttrs.description}
                onChange={(e) => onAttrsInputChange(e)} />
            </Col>
            <Col md={3}>
              <Form.Check type="switch" name={"hasUi"} checked={objAttrs.hasUi} onChange={onCheckboxSelect} />
            </Col>
            <Col md={3}>
            </Col>
          </Row>

          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
            <Col md={3}>{t("I18N_Config")}: *</Col>
          </Row>
          <Row className={classes.admin_pages__field_value}>
            <Col sm={{span: 12}}>
              <textarea className={classes.admin_pages__field_editable} rows={10} style={{minWidth: '100%', minHeight: '400px'}} name="config"
                        value={objAttrs.config} onChange={(e) => onAttrsInputChange(e)} />
            </Col>
          </Row>

          <hr className="solid" style={{ marginTop: '30px' }}></hr>

          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
            <span>{t("I18N_Req_fields")}</span>
          </Row>

          <Row>
            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleCancel}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleSubmit}>
                {t("I18N_Submit")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {errMsg}
              </span>
            </div>
          </Row>
        </Container>

      </Card>
    </>
  );
}
 
export default BizConfigAdmin_NewView;
